module.exports = __webpack_public_path__ + "img/papaw-1.29fe8507.png";